import { AdminSocketRepository } from "../repositories/AdminSocketRepository";

export class ConnectSocketAdmin {
	constructor(private repository: AdminSocketRepository) {}
	execute(): Promise<void> {
		return this.repository.connectSocket();
	}
}
